import { Map } from 'mapbox-gl';

export const isMapboxReady = (mapbox: Map) => {
  return mapbox?.loaded() && mapbox.getStyle() && mapbox.isStyleLoaded();
};
